export const transformYouTubeWatchUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('youtube.com/watch')) return null;

  const videoId = videoUrl.split('v=')[1]?.split('&')[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

export const transformYouTubeShortUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('youtu.be/')) return null;

  const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

export const transformYouTubeShortsUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('youtube.com/shorts/')) return null;

  const videoId = videoUrl.split('/shorts/')[1]?.split('?')[0]?.split('/')[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

export const transformYouTubeLiveUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('youtube.com/live/')) return null;

  const videoId = videoUrl.split('/live/')[1]?.split('?')[0]?.split('/')[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

export const isYouTubeEmbedUrl = (videoUrl: string): boolean => {
  return videoUrl.includes('youtube.com/embed/');
};

export const transformVimeoUrl = (videoUrl: string): string | null => {
  if (!videoUrl.includes('vimeo.com/') || videoUrl.includes('/player.js') || videoUrl.includes('/embed/')) {
    return null;
  }

  const videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
  return videoId && !isNaN(Number(videoId)) ? `https://player.vimeo.com/video/${videoId}` : null;
};

const YOUTUBE_TRANSFORMS = [
  transformYouTubeWatchUrl,
  transformYouTubeShortUrl,
  transformYouTubeShortsUrl,
  transformYouTubeLiveUrl,
];

export const getEmbedUrl = (videoUrl: string): string => {
  if (isYouTubeEmbedUrl(videoUrl)) return videoUrl;

  for (const transform of YOUTUBE_TRANSFORMS) {
    const result = transform(videoUrl);
    if (result) return result;
  }

  const vimeo = transformVimeoUrl(videoUrl);
  if (vimeo) return vimeo;

  return videoUrl;
};
